import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class BeneficiaryAddedStage extends Enum {
  static DISTRIBUTION = {
    key: 'distribution',
    get value() {
      return Lang.t('accounting.distribution');
    }
  };

  /**
   * @param key
   * @returns {boolean}
   */
  static isAddedInDistribution(key) {
    return key === this.DISTRIBUTION.key;
  }
}
